module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-cs-items-box-image-sp-a5c085d4cf22c95a637cc768907aad4c.jpg";